import './MainLoading.scss';

const MainLoading = () => {
    return (
        <div id="loadingParent">
            <div className="loading">
                <span>Loading...</span>
            </div>
        </div>
    );
};

export default MainLoading;